<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_332_321)">
      <path
        d="M8.95472 17.7854C13.3434 17.7854 16.9011 14.2277 16.9011 9.839C16.9011 5.45031 13.3434 1.89258 8.95472 1.89258C4.56604 1.89258 1.0083 5.45031 1.0083 9.839C1.0083 14.2277 4.56604 17.7854 8.95472 17.7854Z"
        stroke="white"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.9929 19.8668L14.5522 15.5342"
        stroke="white"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_332_321">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.879883)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "AppSearchIcon",
};
</script>
